import { useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { Select, Skeleton } from 'antd';
import { Conditional } from 'components/conditional/conditional';
import { setKringloopwijzerId } from 'helpers/api';
import { refreshCallContext } from 'helpers/queries/call-context';
import { FC } from 'react';
import { useNavigate } from 'react-router';
import { KlwMenu } from '../types/menu';

interface AdvisorYearSelectorProps {
  menu: UseQueryResult<KlwMenu>;
}
export const AdvisorYearSelector: FC<AdvisorYearSelectorProps> = ({ menu }) => {
  const nav = useNavigate();
  const queryClient = useQueryClient();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', height: 84 }}>
      <Conditional condition={!menu?.isLoading}>
        <span style={{ textAlign: 'left', lineHeight: '30px', height: 30 }}>
          Bedrijfsnaam:{' '}
          <a
            style={{ cursor: 'pointer', color: '#1677ff' }}
            onClick={() => {
              nav('/deelnemers');
            }}>
            {menu?.data?.kringloopwijzerId !== 0 ? menu?.data?.deelnemerBedrijfsnaam : 'kies een veehouder'}
          </a>
        </span>
        <Conditional condition={!!localStorage.getItem('ProxyKvk')}>
          <span style={{ textAlign: 'left', lineHeight: '30px', height: 30 }}>
            Jaar:{' '}
            <Select
              onChange={val => {
                setKringloopwijzerId(val);
                refreshCallContext(queryClient);
                nav('/');
              }}
              value={parseFloat(localStorage.getItem('KringloopwijzerId') || '0')}
              style={{ width: '150px' }}
              options={menu?.data?.kringloopwijzers?.map(kringloopwijzer => ({ value: kringloopwijzer.id, label: kringloopwijzer.jaarItem }))}
            />
          </span>
        </Conditional>
        <Conditional condition={!localStorage.getItem('ProxyKvk')}>
          <span style={{ textAlign: 'left', lineHeight: '30px', height: 30 }}></span>
        </Conditional>
      </Conditional>
      <Conditional condition={menu?.isLoading}>
        <Skeleton.Button style={{ width: '300px' }} active />
        <Skeleton.Button style={{ width: '300px', marginTop: '-30px' }} active />
      </Conditional>
    </div>
  );
};
